import { LiraContainerIds } from '@client/components/Adv/Lira/liraContainerIds';
import { ADSENSE_STYLES } from '@client/components/Adv/AdSense';
import { Vertical } from '@sbt-web/adv';

type AdSenseStyleConfig = {
  channel_id: string;
  style_id: string;
};

type AdSenseDeviceConfig = {
  desktop: Record<Vertical, AdSenseStyleConfig>;
  msite?: Record<Vertical, AdSenseStyleConfig>;
};

const adsenseConfig: Record<string, AdSenseDeviceConfig> = {
  [LiraContainerIds.listing.belowListing]: {
    desktop: {
      motors: {
        channel_id: 'DESKTOP-BOTTOM-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'DESKTOP-BOTTOM-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      market: {
        channel_id: 'DESKTOP-BOTTOM-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-BOTTOM-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'DESKTOP-BOTTOM-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
    },
    msite: {
      motors: {
        channel_id: 'MSITE-BOTTOM-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'MSITE-BOTTOM-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      market: {
        channel_id: 'MSITE-BOTTOM-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-BOTTOM-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'MSITE-BOTTOM-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
    },
  },
  [LiraContainerIds.listing.aboveListing]: {
    desktop: {
      motors: {
        channel_id: 'DESKTOP-TOP-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'DESKTOP-TOP-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_JOBS,
      },
      market: {
        channel_id: 'DESKTOP-TOP-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-TOP-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'DESKTOP-TOP-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_TUTTI,
      },
    },
    msite: {
      motors: {
        channel_id: 'MSITE-TOP-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'MSITE-TOP-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_JOBS,
      },
      market: {
        channel_id: 'MSITE-TOP-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-TOP-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'MSITE-TOP-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_TUTTI,
      },
    },
  },
  [LiraContainerIds.listing.middle1]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
    msite: {
      subito: {
        channel_id: 'MSITE-MIDDLE-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'MSITE-MIDDLE-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'MSITE-MIDDLE-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'MSITE-MIDDLE-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-MIDDLE-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle2]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
    msite: {
      subito: {
        channel_id: 'MSITE-MIDDLE-LP-TUTTI-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'MSITE-MIDDLE-LP-JOBS-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'MSITE-MIDDLE-LP-MOTORS-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'MSITE-MIDDLE-LP-MARKET-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-MIDDLE-LP-REALESTATE-1-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle3]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-3-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-3-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-3-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-3-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-3-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
    msite: {
      subito: {
        channel_id: 'MSITE-MIDDLE-LP-TUTTI-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'MSITE-MIDDLE-LP-JOBS-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'MSITE-MIDDLE-LP-MOTORS-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'MSITE-MIDDLE-LP-MARKET-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-MIDDLE-LP-REALESTATE-2-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle4]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-4-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-4-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-4-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-4-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-4-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle5]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-5-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-5-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-5-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-5-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-5-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle6]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-6-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-6-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-6-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-6-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-6-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.middle7]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-MIDDLE-LP-TUTTI-7-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-MIDDLE-LP-JOBS-7-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-MIDDLE-LP-MOTORS-7-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-MIDDLE-LP-MARKET-7-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-MIDDLE-LP-REALESTATE-7-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
  [LiraContainerIds.listing.zeroResult]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-TOP-0RESULTS-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-TOP-0RESULTS-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-TOP-0RESULTS-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-TOP-0RESULTS-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-TOP-0RESULTS-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
    msite: {
      subito: {
        channel_id: 'MSITE-TOP-0RESULTS-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'MSITE-TOP-0RESULTS-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'MSITE-TOP-0RESULTS-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'MSITE-TOP-0RESULTS-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-TOP-0RESULTS-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
};

export const getAdSenseConfig = (
  containerId: string,
  vertical: Vertical,
  isMsite: boolean
): AdSenseStyleConfig | undefined => {
  const config = adsenseConfig[containerId];
  if (config) {
    const deviceConfig = isMsite ? config.msite : config.desktop;
    try {
      return deviceConfig?.[vertical];
    } catch {
      return;
    }
  }
};
